import styled from 'styled-components';
import theme from '../../assets/styles/theme';

export const ModalWrapper = styled.div`
  background: ${theme.colors.neutral.bg.weak};
  ${({ sizeMd, modalMarginSize }) =>
    sizeMd
      ? `
            margin: 10% auto;
            border-radius: ${theme.borderRadius['border-radius-2']};
            `
      : `
            margin: ${modalMarginSize};
            border-radius: ${theme.borderRadius['border-radius-4']};
            width: 504px;
            @media ${theme.sizesResponsive.xxs} {
              width: 100%;
            }
 `}
`;

export const ModalContent = styled.div`
  ${({ sizeMd }) =>
    sizeMd
      ? `
            min-height: 490px;
            `
      : `
            padding: ${theme.spacing['spacing-11']} ${theme.spacing['spacing-13']} ${theme.spacing['spacing-9']}
            ${theme.spacing['spacing-13']};
            @media ${theme.sizesResponsive.xxs} {
              padding: ${theme.spacing['spacing-11']} ${theme.spacing['spacing-5']} ${theme.spacing['spacing-5']}
              ${theme.spacing['spacing-5']};
            }
 `}
`;

export const ModalIconBase = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const IconWrapper = styled.div`
  position: absolute;
  margin-top: ${theme.spacing['spacing-5']};
  margin-right: ${theme.spacing['spacing-5']};
`;

export const IconMd = styled.img`
  cursor: pointer;
  padding-top: 10px;
  padding-right: 10px;
`;
